module.exports = __webpack_public_path__ + "img/panel-wrong-search.2991c40a.svg";